import {
  BUYER_INFO_EXTRATION_MODE,
  CONFIRM_SALE_MODE,
  WAITING_CONFIRMATION_MODE,
  PAYMENT_MODE,
  SUCCESSFUL_PAYMENT,
} from '@src/components/Checkout/constants';

import type { CheckoutMode } from '../types';

export interface StepChrome {
  /** The step draws its own cards, so the outlet must not add a frame around it. */
  flush: boolean;
  showsSidebar: boolean;
  showsHeader: boolean;
}

const DEFAULT_CHROME: StepChrome = { flush: false, showsSidebar: true, showsHeader: true };

/** The placeholder brings its own cards, and it keeps the header and summary the buyer already sees. */
const BOOTSTRAP_CHROME: StepChrome = { flush: true, showsSidebar: true, showsHeader: true };

const CHROME_BY_MODE: Partial<Record<CheckoutMode, StepChrome>> = {
  [PAYMENT_MODE]: { flush: true, showsSidebar: true, showsHeader: true },
  // The additional info step is already a card of its own; the outlet frame would double it.
  [BUYER_INFO_EXTRATION_MODE]: { flush: true, showsSidebar: true, showsHeader: true },
  // It wears the same skeleton as the bootstrap while it works — that skeleton draws its own
  // cards, so the outlet frame would double them.
  [CONFIRM_SALE_MODE]: { flush: true, showsSidebar: true, showsHeader: true },
  [WAITING_CONFIRMATION_MODE]: { flush: true, showsSidebar: true, showsHeader: true },
  // the step opens with its own greeting instead of the checkout title.
  [SUCCESSFUL_PAYMENT]: { flush: true, showsSidebar: false, showsHeader: false },
};

export const resolveStepChrome = (mode: CheckoutMode, bootstrapping = false): StepChrome =>
  bootstrapping ? BOOTSTRAP_CHROME : CHROME_BY_MODE[mode] ?? DEFAULT_CHROME;
